import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Skills from '../views/Standardistion/SkillsUser.vue'
import ViewSkills from '../views/Standardistion/ViewSkillUser.vue'
import Job from '../views/Standardistion/JobUser.vue'
import ViewJob from '../views/Standardistion/ViewJobUser.vue'
import Signin from '../views/auth/SignIn.vue'
import Signup from '../views/auth/SignUp.vue'
import ForgotPassword from '../views/auth/ForgotPassword.vue'
import StandardisationTable from '../views/Standardistion/standardisationTable.vue'
import PrivacyPolicies from '../views/PrivacyPolicies.vue'
import CareerManagement from '../views/Career/CareerManagement.vue'
import CvParser from '../views/Career/CvParser.vue'
import CareerDashboard from '../views/Career/CareerDashboard.vue'
import RoleDetails from '../views/Career/RoleDetails.vue'
import Profile from '../views/Profile.vue'
import DashboardLayout from '../views/DashboardLayout.vue'
import OccupationCatalog from '../views/Occupations/OccupationCatalog.vue'

const routes: Array<RouteRecordRaw> = [
  // One landing page. The standardization tools are reachable from the footer
  // and, once signed in, from the dashboard.
  {
    path: '/',
    name: 'landing-page',
    component: CareerManagement
  },
  // Public occupation catalogue: anyone can browse, no login.
  // Our data lives here: signed-in users only (the API enforces it too).
  { path: '/occupations', name: 'occupations', component: OccupationCatalog, meta: { requiresAuth: true } },
  { path: '/occupations/:id', name: 'occupation', component: RoleDetails, meta: { requiresAuth: true } },
  { path: '/career-management', redirect: { name: 'landing-page' } },
  { path: '/standardisation', redirect: { name: 'landing-page' } },
  {
    path: '/skills',
    name: 'skills',
    component: Skills
  },
  {
    path: '/view-skills',
    name: 'view-skills',
    component: ViewSkills
  },
  {
    path: '/job',
    name: 'job',
    component: Job
  },
  {
    path: '/view-job',
    name: 'view-job',
    component: ViewJob
  },
  // Unified dashboard with vertical sidebar
  {
    path: '/dashboard',
    component: DashboardLayout,
    children: [
      {
        path: 'profile/:id',
        name: 'dashboard-profile',
        component: Profile
      },
      {
        path: 'cv',
        name: 'dashboard-cv',
        component: CvParser
      },
      {
        path: 'careers',
        name: 'dashboard-careers',
        component: CareerDashboard
      },
      {
        path: 'standardization/:id',
        name: 'dashboard-standardization',
        component: StandardisationTable
      },
      {
        path: 'job/:id',
        name: 'dashboard-job-detail',
        component: RoleDetails, props: { compare: true }
      }
    ]
  },
  // Redirects from old routes to new dashboard routes
  {
    path: '/profile/:id',
    redirect: to => ({ name: 'dashboard-profile', params: { id: to.params.id } })
  },
  {
    path: '/profileCv/:id',
    redirect: to => ({ name: 'dashboard-profile', params: { id: to.params.id } })
  },
  {
    path: '/cv-parser',
    redirect: { name: 'dashboard-cv' }
  },
  {
    path: '/cv-parser-tool',
    redirect: { name: 'dashboard-cv' }
  },
  {
    path: '/career-dashboard',
    redirect: { name: 'dashboard-careers' }
  },
  {
    path: '/career-dashboard-tool',
    redirect: { name: 'dashboard-careers' }
  },
  {
    path: '/standardisation-table/:id',
    redirect: to => ({ name: 'dashboard-standardization', params: { id: to.params.id } })
  },
  {
    path: '/standardisation-tableCv/:id',
    redirect: to => ({ name: 'dashboard-standardization', params: { id: to.params.id } })
  },
  {
    path: '/data-sceintist/:id',
    redirect: to => ({ name: 'dashboard-job-detail', params: { id: to.params.id } })
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicies
  },
  {
    path: '/auth/',
    children:[
      {
        path: 'signin',
        name: 'signin',
        component: Signin
      },
      {
        path: 'signup',
        name: 'signup',
        component: Signup
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: ForgotPassword
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }; // صفحه را به ابتدای صفحه اسکرول می‌کند
  }
})

// Signed-out visitors go to sign in and come back to the page they asked for.
router.beforeEach((to) => {
  if (to.meta.requiresAuth && !localStorage.getItem('auth_token')) {
    return { name: 'signin', query: { redirect: to.fullPath } }
  }
})

export default router
